import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { sortBy, filter } from 'lodash'
import moment from 'moment'
import DtoDetailPiezometerMeasure from '../../dto/DtoDetailPiezometerMeasure'
import { Timeserie, IChart, Area } from 'react-aquasys'
import i18n from 'simple-react-i18n'

class AnnualChartPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			width: 0
		}
	}

	componentDidMount() {
		this.setState({ width: this.refs.refWidth.offsetWidth })
	}

	getPiezometerMeasuresMax = () => {
		return sortBy(this.props.piezometerMeasuresMax, ['date'])
	}
	getPiezometerMeasuresMin = () => {
		return sortBy(this.props.piezometerMeasuresMin, ['date'])
	}
	getPiezometerMeasuresMoyenne = () => {
		return sortBy(this.props.piezometerMeasuresMoyenne, ['date'])
	}
	formatter = (measures) => {
		return measures.map((measure) => {
			return {
				x: measure.date,
				y: measure.measure
			}
		})
	}
	getChart = () => {
		const dateNow = moment().subtract(1, 'years')
		const yearMeasures = filter(this.props.piezometerMeasures, (o) => {
			return moment(o.date).isSameOrAfter(dateNow)
		})
		const year = yearMeasures.map((measure) => {
			return Object.assign({}, measure, {
				date: parseInt(moment(measure.date).format('x'))
			})
		})
		const data = this.formatter(year)
		const dataMax = this.formatter(this.getPiezometerMeasuresMax())
		const dataMin = this.formatter(this.getPiezometerMeasuresMin())
		const dataMoyenne = this.formatter(this.getPiezometerMeasuresMoyenne())
		const maxMin = dataMax.map((measure) => {
			const minSearch = dataMin.find((o) => {
				return o.x === measure.x
			})
			if (minSearch) {
				const concatMeasure = [].concat(minSearch.y, measure.y)
				return Object.assign({}, measure, {
					y: concatMeasure
				})
			}
			return measure
		})
		const annualSerie = new Timeserie({ data: data, color: 'black', name: i18n.annualChronicle })
		const averageSerie = new Timeserie({ data: dataMoyenne, color: 'green', name: i18n.middleChronicle, style: 'dash' })
		const areaMinMax = new Area({ data: maxMin, color: 'steelblue', name: i18n.envelope })
		const series = [areaMinMax, averageSerie, annualSerie]
		return (
			<IChart width={ this.state.width } height='450'
				series={ series }
				zoomable legend />
		)
	}

	render() {
		return (
			<div className='row white-background' ref='refWidth'>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ i18n.annualChart }
				</div>
				<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin no-padding'>
					{ this.getChart() }
				</div>
			</div>
		)
	}
}

AnnualChartPanel.propTypes = {
	piezometerMeasures: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailPiezometerMeasure)),
	piezometerMeasuresMax: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailPiezometerMeasure)),
	piezometerMeasuresMin: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailPiezometerMeasure)),
	piezometerMeasuresMoyenne: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailPiezometerMeasure))
}

AnnualChartPanel.defaultProps = {
	piezometerMeasures: [],
	piezometerMeasuresMax: [],
	piezometerMeasuresMin: [],
	piezometerMeasuresMoyenne: []
}

export default AnnualChartPanel



// WEBPACK FOOTER //
// ./src/station/components/piezometer/AnnualChartPanel.js